export function stringToProperty(path, obj) {
	return path.split('.').reduce(function (prev, curr) {
		return prev ? prev[curr] : undefined
	}, obj || self)
}

export function _parseJSON(str) {
	return JSON.parse(str);
}

export function hasOwnNestedProperty(obj, propertyPath, callback) {
	if (!propertyPath) {
		return false;
	}
	let result = propertyPath.split('.').every(function (x) {
		// console.log('propertyPath', x +' in obj',x in obj,obj);
		if (typeof obj != 'object' || obj === null || !x in obj) {
			return false;
		}

		obj = obj[x];
		return true;
	});
	return result;
}

export function length(obj){
	if(typeof obj == 'object'){
		let size = 0, key;
		for (key in obj) {
			if (obj.hasOwnProperty(key)) size++;
		}
		return size;
	}else if (typeof obj == 'array'){
		return obj.length;
	}
	else return undefined;
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/object.formats.js